import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/svg/logo-small.svg'


const _hoisted_1 = { class: "flex justify-between items-center px-4 md:px-10 bg-white border-b border-secondary-light" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "image suggest"
}, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_4 = {
  key: 1,
  class: "py-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_UserProfileDropdown = _resolveComponent("UserProfileDropdown")

  return (_openBlock(), _createBlock("nav", _hoisted_1, [
    _createVNode(_component_router_link, {
      class: "font-semibold md:text-22",
      to: { name: 'dashboard' }
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    (_ctx.isAuthenticated)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode(_component_UserProfileDropdown, { "user-name": _ctx.userName }, null, 8, ["user-name"])
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            class: "text-secondary mr-6 text-10 md:text-14",
            to: { name: 'sign-in' }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('actions.sign-in')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            class: "text-secondary text-10 md:text-14",
            to: { name: 'sign-up' }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('actions.sign-up')), 1)
            ]),
            _: 1
          })
        ]))
  ]))
}